module.exports = __webpack_public_path__ + "assets/icons/ic_print-413d.svg";